import { throttle, isDesktop } from '../modules/utils'

declare var $

interface LinkedBlock {
  slug: string
  label: string
	el: HTMLElement
  top: number
}

export class InpageNavigation {

	el: HTMLElement
  wrapperEl: HTMLElement
  nav: LinkedBlock[]
  scrollThreshold: number
  scrollIID: ReturnType<typeof setTimeout>
  resizeIID: ReturnType<typeof setTimeout>

  constructor (el) {
    this.el = el
    this.wrapperEl = this.el.querySelector('.inpage-navigation-wrapper')
    this.nav = []
    this.scrollThreshold = $(this.el).offset().top
    this.init()
  }

  init() {
    // Build linkable elements
    $('[data-nav-label]').each((i,el) => {
      const label = $(el).data('nav-label')
      if (label && label !== '') {
        const slug = this.slugify(label)
        this.nav.push({
          slug: slug,
          label: label,
          el: el,
          top: $(el).offset().top
        })
      }
    })

    this.buildNav()
    this.enableNav()

  }

  buildNav() {
    const htmlArr = []
    for (const i in this.nav) {
      htmlArr.push('<a class="inpage-link" href="#'+this.nav[i].slug+'">'+this.nav[i].label+'</a>')
    }
    $('.inpage-navigation-nav', this.el).html(htmlArr.join(''))
  }

  enableNav() {
    $(this.el)
      .on('click', 'a[href]', (e) => {
        e.preventDefault()
        const slug = $(e.currentTarget).attr('href').replace(/^#/, "")
        this.navigateTo(slug)
      })
    $(window)
      .on('scroll', () => {
        throttle(this.scrollWatcher(), 100)
      })
      .on('resize', () => {
        clearTimeout(this.scrollIID)
        this.scrollIID = setTimeout(() => {
          this.resizeWatcher()
        }, 100)
      })

    this.resizeWatcher()
  }

  navigateTo(slug) {
    const foundEls = this.nav.filter((item) => {
      return item.slug === slug
    })
    if (foundEls.length) {
      const offset = isDesktop()? ((window.pageYOffset > $(foundEls[0].el).offset().top - 180)?180:80) : 0

      $('html, body').animate({
        scrollTop: $(foundEls[0].el).offset().top - offset
      }, 1000)
    }
  }

  scrollWatcher() {
    const scroll = window.pageYOffset
    let activeTab:LinkedBlock | null = null
    $(this.el).toggleClass('stuck', scroll > this.scrollThreshold)
    for (const i in this.nav) {
      if (this.nav[i].top < scroll * 1.2) {
        activeTab = this.nav[i]
      } else {
        break;
      }
    }
    $('.inpage-link', this.el).removeClass('active')
    if (activeTab) {
      $('.inpage-link[href="#'+activeTab.slug+'"]', this.el).addClass('active')
    }
  }

  resizeWatcher() {
    this.scrollThreshold = $(this.el).offset().top
    for (const i in this.nav) {
      this.nav[i].top = $(this.nav[i].el).offset().top
    }
    this.scrollWatcher()
  }

  // Helper

  slugify(text:string) {
    return text
      .toLowerCase()
      .trim()                      // Trim leading/trailing whitespace
      .replace(/\s+/g, '-')        // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, '') // Remove all non-word chars, except hyphens and spaces
      .replace(/-+/g, '-')         // Replace multiple hyphens with a single hyphen
      .replace(/^-+/, '')          // Trim hyphens from start
      .replace(/-+$/, '');         // Trim hyphens from end
  };

}